import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { VariantPricing, VariantPricingUpdate } from '../types';

export interface PricingApiContract {
  variantPricing(sku: string): Promise<VariantPricing[]>;
  updateVariantPricing(sku: string, updates: VariantPricingUpdate[]): Promise<VariantPricing[]>;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    pricing: PricingApiContract;
  }
}

/**
 * A service to interact with variant pricing via the SparkLayer API.
 */
export class PricingApi extends ApiService implements PricingApiContract {
  public variantPricing(sku: string): Promise<VariantPricing[]> {
    return this.api.proxy({
      method: 'GET',
      path: '/v1/pricing/{id}',
      params: { id: sku },
    });
  }

  public updateVariantPricing(
    sku: string,
    updates: VariantPricingUpdate[],
  ): Promise<VariantPricing[]> {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/pricing/{id}',
      params: { id: sku },
      payload: updates,
    });
  }
}
